
/*
 * VNCtask : VNCtask – the easy to use Task Management & To-Do List application. Stay organized. Anytime! Anywhere!
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

export * from "./header/header.component";
export * from "./advanced-search/advanced-task-search.component";
export * from "./task-settings/task-settings-dialog/task-settings-dialog.component";
export * from "./task-settings/task-service-desk-dialog/task-service-desk-dialog.component";
export * from "./task-settings/task-help-faq-dialog/task-help-faq-dialog.component";
export * from "./task-settings/task-general-settings-dialog/task-general-settings.component";
export * from "./task-settings/task-changelog-dialog/task-changelog-dialog.component";
export * from "./task-settings/task-aboutus-dialog/task-aboutus-dialog.component";
export * from "./sidebar/sidebar.component";
export * from "./user-profile/user-profile.component";
export * from "./sidebar/sidebar-drawer.component";
export * from "./sidebar/task-option-list.component";
export * from "./sidebar/tag-option-list.component";
export * from "./task-list/task-list.component";
export * from "./task-list-item/task-list-item.component";
export * from "./task-details/task-details.component";
export * from "./task-filter/task-filter.component";
export * from "./task-autocomplete/task-autocomplete.component";
export * from "./task-compose";
export * from "./task-dialogs/confirm-dialog.component";
export * from "./task-reminder/reminder-dialog.component";
export * from "./task-header-menubar/task-header-menubar.component";
export * from "./task-statistics/task-statistics.component";
export * from "./task-mutiple-select/task-mutiple-select.component";
export * from "./task-bulk-edit-dialog/task-bulk-edit-dialog.component";
export * from "./main-layout/task-main-layout.component";
export * from "./pipes/task-project-search.pipe";
export * from "./pipes/task-user-search.pipe";
export * from "./task-toolbar/task-toolbar.component";
export * from "./task-image-cropper-dialog/task-image-cropper-dialog.component";
export * from "./task-login-user-profile/task-login-user-profile.component";
export * from "./task-avatar/task-avatar.component";
export * from "./task-add-field-dialog/task-add-field-dialog.component";
export * from "./task-add-attachment-dialog/task-add-attachment-dialog.component";
export * from "./task-attachment-option-dialog/task-attachment-option-dialog.component";
export * from "./task-record-voice-msg-dialog/task-record-voice-msg-dialog.component";
export * from "./task-add-reminder-dialog/task-add-reminder-dialog.component";
export * from "./mobile-search/mobile-search.component";
export * from "./advance-search-options";
export * from "./task-notifications";
export * from "./task-date-picker/task-date-picker.component";
export * from "./under-development/under-development.component";
export * from "./media-preview/media-preview.component";
export * from "./registration/registration-form/registration-form.component";
export * from "./registration/registration-activation/registration-activation.component";
export * from "./forgot-password/forgot-password-form/forgot-password-form.component";
export * from "./forgot-password/forgot-password-info/forgot-password-info.component";
export * from "./forgot-password/reset-password-form/reset-password-form.component";
export * from "./change-password/change-password-form/change-password-form.component";
export * from "./task-deactivate-account/task-account-deactivate-confirmation/task-account-deactivate-confirmation.component";
export * from "./task-deactivate-account/task-account-deactivate-feedback/task-account-deactivate-feedback.component";
export * from "./task-settings/task-legal-notice-dialog/task-legal-notice-dialog.component";
export * from "./sidebar/folder-option-list.component";
export * from "./create-list-dialog/create-list-dialog.component";
export * from "./sidebar/folder-option-list-item.component";
export * from "./registration/registration-link-expired/registration-link-expired.component";
export * from "./sidebar/users-management.component";
export * from "./sidebar/invite-users.component";
export * from "./sidebar/archive-users.components";
export * from "./save-query-dialog/save-query-dialog.component";
export * from "./save-search-dialog/save-search-dialog.component";
export * from "./sidebar/location-option-list.component";
export * from "./create-location-dialog/create-location-dialog.component";
export * from "./timelog-history/timelog-history-dialog.component";
export * from "./log-time/log-time-dialog.component";
export * from "./task-watchers-dialog/task-watchers-dialog.component";
export * from "./pipes/locale-date.pipe";
export * from "./description-diff/description-diff.component";
export * from "./logout-confirmation/logout-confirmation.component";
